import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {StyledAccordion} from '@igp/shared/components/accordion';
import {LocalizedText} from '@igp/shared/components/i18n';
import {KeyValueCell, KeyValueColumn, KeyValueTable} from '@igp/shared/components/key-value-table';
import type {UserProfileViewModelKeys} from '@igp/shared/features/user-profile';
import {useUserProfileDetails} from '@igp/shared/features/user-profile';

import {PlayerBackpackInfo} from './PlayerBackpackInfo';
import {PlayerCashBonuses} from './PlayerCashBonuses';
import {PlayerReferralSummary} from './PlayerReferralSummary';

const localized = defineMessages({
    title: {
        id: 'PlayerMarketingInfo_title',
        defaultMessage: 'Marketing Info',
    },
    registerMarketingCode: {
        id: 'userMarketingInfo_registerMarketingCode',
        defaultMessage: 'Register Marketing Code',
    },
});

type PlayerMarketingInfoProps = {uid: string};

export function PlayerMarketingInfo({uid}: PlayerMarketingInfoProps) {
    const {formatMessage} = useIntl();
    const userProfileKeys: UserProfileViewModelKeys[] = ['register_marketing_code'];
    const {item: user} = useUserProfileDetails({
        id: uid,
        fields: userProfileKeys,
        viewType: 'MarketingInfo',
        displayName: localized.title,
    });
    return (
        <StyledAccordion
            header={<LocalizedText label={localized.title} />}
            componentId="PlayerMarketingInfo"
            isCollapsed
            unmountOnCollapse
            children={
                <>
                    <KeyValueTable>
                        <KeyValueColumn>
                            <KeyValueCell title={formatMessage(localized.registerMarketingCode)} withEmptyCheck>
                                {user?.marketing_info?.register_marketing_code}
                            </KeyValueCell>
                        </KeyValueColumn>
                    </KeyValueTable>
                    <PlayerCashBonuses uid={uid} />
                    <PlayerBackpackInfo uid={uid} />
                    <PlayerReferralSummary uid={uid} />
                </>
            }
        />
    );
}
